// New Code

import { FC } from "react";
import { Modal, Box } from "@mui/material";
import { CommonStyle } from "Components";
import { SidebarModalLayoutType } from "DataTypes/Layout";

const SidebarModalLayout: FC<SidebarModalLayoutType> = (
  props: SidebarModalLayoutType
) => {
  const { content, open, onClose } = props;

  const body2 = <Box sx={{ ...sxMain2 }}>{content}</Box>;

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body2}
      </Modal>
    </div>
  );
};

export default SidebarModalLayout;

const sxMainBody = {
  top: "57%",
  left: "9%",
  transform: `translate( 0%, -${50}%)`,
  position: "absolute",
  outline: "none",
  height: "84%",
  borderRadius: 1.25,
};

const sxMain2 = {
  ...sxMainBody,
  ...CommonStyle.sxRow,
  width: "90%",
  "&>div": {
    ":first-of-type": {
      height: "100%",
      ...CommonStyle.sxWhiteBox,
    },
    ":nth-of-type(3)": {
      height: "100%",
      ...CommonStyle.sxWhiteBox,
    },
  },
};